﻿
(function ($, document) {

    $(document).on('click', '.js-register-btn', function (e) {
        e.preventDefault();
        var $addButton = $(this);
        var $removeButton = $addButton.siblings('.js-unregister-btn');
        var payload = $addButton.siblings('.js-payload').val();
        var data = { payload: payload, returnUrl: location.href.replace(location.hash, '') };

        var request = $
            .ajax({
                url: '/api/wishlist/register',
                data: JSON.stringify(data),
                method: 'POST',
                contentType: "application/json"
            })
            .done(function (msg) {
                if (msg == 'success') {
                    $addButton.hide();
                    $removeButton.show();
                }
                else {
                    window.location = msg;
                }
            })
        ;
    });

    $(document).on('click', '.js-unregister-btn', function (e) {
        e.preventDefault();
        var $removeButton = $(this);
        var $addButton = $removeButton.siblings('.js-register-btn');
        var payload = $addButton.siblings('.js-payload').val();
        var data = { payload: payload };

        var request = $
            .ajax({
                url: '/api/wishlist/unregister',
                data: JSON.stringify(data),
                method: 'POST',
                contentType: "application/json"
            })
            .done(function (msg) {
                if (msg == 'success') {
                    $addButton.show();
                    $removeButton.hide();
                }
                else {
                    window.location.reload(true);
                }
            })
        ;
    });

    $(document).ready(function () {

    });

})(jQuery, document);